export const selectDonation = ({donation}) => donation;
